import * as React from "react";

interface Props {
    columns: Array<string>;
    totals: Record<string, string | null>;
    columnClasses: Record<string, string>;
}

export default class ReportTableFooter extends React.Component<Props> {
    public render(): React.ReactNode {
        return (
            <tfoot className="report-table-footer">
                <tr>
                    {this.props.columns.map(column => {
                        let text = "";
                        const total = this.props.totals[column];

                        if(total) {
                            text = total;
                        }

                        const className = this.props.columnClasses[column] || "";

                        return (
                            <th key={column} className={className}>
                                {text}
                            </th>
                        );
                    })}
                </tr>
            </tfoot>
        );
    }
}
